export const mapViewBy = {
  chart: {
    label: 'riskScaleAndInterpretation.chart',
    value: 'Chart',
    isI18n: true,
  },
  table: {
    label: 'riskScaleAndInterpretation.table',
    value: 'Table',
    isI18n: true,
  },
}

export const TYPE_CHART_TREND_OF_SCORE = [
  {
    name: 'Probability of Default (PD)',
    id: 1,
    color: '#006AA6',
    dataKey: 'data1',
    isBarChart: true,
  },
  {
    name: 'Company Score',
    id: 2,
    color: '#FFCD60',
    dataKey: 'data2',
    isLineChart: true,
  },
  {
    name: 'Model Segment Score',
    id: 3,
    color: '#FF596A',
    dataKey: 'data3',
    isLineChart: true,
  },
]

export const HISTORICAL_CHANGE_COLOR = [
  '#C64D57',
  '#EB6671',
  '#F38C6B',
  '#FFD669',
  '#FFDE86',
  '#AFEBC6',
  '#87D4A4',
  '#54BB7B',
]
